const SW_URL = '/sw.js';

/** 生产环境注册 Service Worker */
export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL, { scope: './' })
      .catch((error: unknown) => {
        console.warn('[PWA] Service Worker 注册失败:', error);
      });
  });
}
